// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media screen and (max-width: 768px)
{
  #emailerror
  {
    margin-top: -100px;
  }
  .AcknowledgeSection
  {
    margin-top: -5px;
  }
  
   .troubleSection
  {
    position: relative;
    top: -35px;
    /*left:200px;*/
    text-align: end;
  }


  .registerSection
  {
   position: relative;
   top: -10px;
   /*left: 60px;*/
   text-align: center;
  }

  .privacyPolicy
  {
    white-space: pre;
  }

  .btn-box
  {
    margin-top: -26px;
    margin-bottom: 10px;
  }

}

@media screen and (max-width: 468px)
{
  #emailerror
  {
    margin-top: -25px;
  }

  .AcknowledgeSection
  {
    margin-top: -5px;
  }

 

  

  .registerSection
  {
    position: relative;
    top: -10px;
    /*left: 60px;*/
    text-align: center;
  }

  .privacyPolicy
  {
    white-space: pre;
  }

  .btn-box
  {
    margin-top: -26px;
    margin-bottom: 10px;
  }
}

/*Index page login*/
.loginSection
{
  display: none;
}


@media screen and (max-width: 768px)
{
  .loginSection
  {
    display: block;
    padding-top: 70px;
    padding-bottom: 0px;
  }

  .about-section
  {
    margin-top: -60px;
  }

  .coming-soon-section .outer-box{
    margin-top:0px;
  }
         
}

.about-section
{
  padding-top: 100px;
}
.features-section-two
{
  padding-top: 0px;
  padding-bottom: 15px;
}

.app-section
{
  padding-top: 50px;
  padding-bottom: 0px;
}

.news-section
{
  padding-top: 20px;
  padding-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/mynewstyle.css"],"names":[],"mappings":";AACA;;EAEE;;IAEE,kBAAkB;EACpB;EACA;;IAEE,gBAAgB;EAClB;;GAEC;;IAEC,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;EACjB;;;EAGA;;GAEC,kBAAkB;GAClB,UAAU;GACV,cAAc;GACd,kBAAkB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;EACrB;;AAEF;;AAEA;;EAEE;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;;;;;EAMA;;IAEE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;AACf;;;AAGA;;EAEE;;IAEE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;AAEF;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["\r\n@media screen and (max-width: 768px)\r\n{\r\n  #emailerror\r\n  {\r\n    margin-top: -100px;\r\n  }\r\n  .AcknowledgeSection\r\n  {\r\n    margin-top: -5px;\r\n  }\r\n  \r\n   .troubleSection\r\n  {\r\n    position: relative;\r\n    top: -35px;\r\n    /*left:200px;*/\r\n    text-align: end;\r\n  }\r\n\r\n\r\n  .registerSection\r\n  {\r\n   position: relative;\r\n   top: -10px;\r\n   /*left: 60px;*/\r\n   text-align: center;\r\n  }\r\n\r\n  .privacyPolicy\r\n  {\r\n    white-space: pre;\r\n  }\r\n\r\n  .btn-box\r\n  {\r\n    margin-top: -26px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width: 468px)\r\n{\r\n  #emailerror\r\n  {\r\n    margin-top: -25px;\r\n  }\r\n\r\n  .AcknowledgeSection\r\n  {\r\n    margin-top: -5px;\r\n  }\r\n\r\n \r\n\r\n  \r\n\r\n  .registerSection\r\n  {\r\n    position: relative;\r\n    top: -10px;\r\n    /*left: 60px;*/\r\n    text-align: center;\r\n  }\r\n\r\n  .privacyPolicy\r\n  {\r\n    white-space: pre;\r\n  }\r\n\r\n  .btn-box\r\n  {\r\n    margin-top: -26px;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n/*Index page login*/\r\n.loginSection\r\n{\r\n  display: none;\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px)\r\n{\r\n  .loginSection\r\n  {\r\n    display: block;\r\n    padding-top: 70px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .about-section\r\n  {\r\n    margin-top: -60px;\r\n  }\r\n\r\n  .coming-soon-section .outer-box{\r\n    margin-top:0px;\r\n  }\r\n         \r\n}\r\n\r\n.about-section\r\n{\r\n  padding-top: 100px;\r\n}\r\n.features-section-two\r\n{\r\n  padding-top: 0px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.app-section\r\n{\r\n  padding-top: 50px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.news-section\r\n{\r\n  padding-top: 20px;\r\n  padding-bottom: 0px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
